import ReactDOM from 'react-dom';

// Caps a scrolling table at the space left below it, so the bottom of its panel (and the
// "loading more" hint) stay on screen instead of running past the window. `reserve` is the
// room kept under the table for that footer.
export function fitToViewport(component, { reserve = 90, min = 260 } = {}) {
    // eslint-disable-next-line react/no-find-dom-node
    const el = component && ReactDOM.findDOMNode(component);
    if (!el || !el.getBoundingClientRect) {
        return;
    }

    const top = el.getBoundingClientRect().top + window.pageYOffset;
    const value = `${Math.max(window.innerHeight - top - reserve, min)}px`;
    if (el.style.maxHeight !== value) {
        el.style.maxHeight = value;
    }
}
